import * as Yup from "yup";
import i18next from "i18next";

export const ChangePasswordSchema = () => Yup.object({

    old_password: Yup.string().required(i18next.t('profile.error_old_password')),
    new_password: Yup.string().required(i18next.t('profile.error_new_password')),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('new_password'), null], i18next.t('profile.error_password_match'))
        .required(i18next.t('profile.error_confirm_password')),

});